var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "container content-padding" },
    [
      _vm.inboxes === null
        ? [_c("loader")]
        : [
            _vm.inboxes.length === 0 && _vm.queryData.page === 0
              ? [
                  _c("notification", {
                    attrs: { classname: "alert-info", body: "message.no_data" }
                  })
                ]
              : [
                  _c("h2", [_vm._v(_vm._s(_vm.$t("message.inbox.inbox")))]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card panel-inbox" }, [
                    _c("div", { staticClass: "card-body" }, [
                      _c(
                        "ul",
                        { staticClass: "list-unstyled" },
                        _vm._l(_vm.inboxes, function(inbox) {
                          return _c("inbox", {
                            key: inbox.id,
                            attrs: { inbox: inbox }
                          })
                        }),
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-center" }, [
                    _vm.state.isMore
                      ? _c(
                          "button",
                          {
                            staticClass: "button -cyan",
                            attrs: { disabled: _vm.state.isFetching },
                            on: { click: _vm.fetchInboxes }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t(_vm.isLoadMore)) +
                                "\n        "
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ]
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b3b1e4ee", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3b1e4ee","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inbox/Index.vue
// module id = 1783
// module chunks = 0